import { PRODUCT_LINE_CODE } from '../../../../../shared/constants/product-lines-codes';
import { aggregates } from './aggregates';
import { cementBulk } from './cement-bulk';
import { cementBag } from './cement-bag';
import { readymix } from './readymix';

export const niConfig = {
  [PRODUCT_LINE_CODE.AGGREGATES]: aggregates,
  [PRODUCT_LINE_CODE.BULK_CEMENT]: cementBulk,
  [PRODUCT_LINE_CODE.BAG_CEMENT]: cementBag,
  [PRODUCT_LINE_CODE.READY_MIX]: readymix,
};
